/* eslint-disable */
import React, { useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';

import style from './style';

const { tableRowStyle, subtableRowStyle } = style;

export default function Row({
  index = 0,
  row,
  limit,
  thereIsComponent,
  event = () => {},
  active = false,
  checkbox = true,
}) {
  const [activo, setActivo] = useState(active);

  return (
    <React.Fragment>
      <TableRow
        sx={tableRowStyle}
        onClick={() => {
          event(index, !activo);
          setActivo(!activo);
        }}
      >
        {checkbox ? (
          <TableCell align="center">
            <Checkbox edge="start" checked={activo} />
          </TableCell>
        ) : null}

        {row.map((data, j) =>
          j < limit ? (
            <TableCell key={j} align="center">
              {thereIsComponent ? thereIsComponent(row, j) : data}
            </TableCell>
          ) : null
        )}
      </TableRow>
      <TableRow sx={subtableRowStyle}></TableRow>
    </React.Fragment>
  );
}
